// The widget's icon set: inline SVG, so the bundle carries no icon font and no
// icon package. Extracted from App.tsx, which was 1159 lines and opened with
// 38 of them before any behaviour.
import type { ComponentChildren } from "preact";

export type IconProps = { class?: string };
function svg(path: ComponentChildren) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
      stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      {path}
    </svg>
  );
}
export const BookIcon = () => svg(<><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" /><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" /></>);
export const CloseIcon = () => svg(<path d="M18 6 6 18M6 6l12 12" />);
export const BackIcon = () => svg(<path d="m15 18-6-6 6-6" />);
export const SearchIcon = () => svg(<><circle cx="11" cy="11" r="7" /><path d="m21 21-4.3-4.3" /></>);
export const SendIcon = () => svg(<path d="M12 19V5M5 12l7-7 7 7" />);
export const ExpandIcon = () => svg(<path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3M3 16v3a2 2 0 0 0 2 2h3m13-5v3a2 2 0 0 0-2 2h-3" />);
export const CompressIcon = () => svg(<path d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3M3 16h3a2 2 0 0 1 2 2v3m13-5h-3a2 2 0 0 0-2 2v3" />);
export const MinusIcon = () => svg(<path d="M5 12h14" />);
export const LinkIcon = () => svg(<><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" /><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" /></>);
export const CheckIcon = () => svg(<path d="M20 6 9 17l-5-5" />);
// Four-point spark: the AI answer / thinking marker.
export const SparkIcon = () => svg(<><path d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9z" /><path d="M19 17l.8 2.2L22 20l-2.2.8L19 23l-.8-2.2L16 20l2.2-.8z" /></>);
// Magnifier with an x in the lens: nothing matched the search.
export const NoResultIcon = () => svg(<><circle cx="11" cy="11" r="8" /><path d="m21 21-4.3-4.3" /><path d="m13.5 8.5-5 5M8.5 8.5l5 5" /></>);
export const FolderIcon = ({ class: c }: IconProps) => (
  <svg class={c} viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
    stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <path d="M4 20a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5l2 3h7a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2z" />
  </svg>
);
export const ChevronRight = () => svg(<path d="m9 18 6-6-6-6" />);
export const ThumbUpIcon = () => svg(<><path d="M7 22V11" /><path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 3a2.5 2.5 0 0 1 3 2.88z" /></>);
export const ThumbDownIcon = () => svg(<><path d="M17 2v11" /><path d="M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 21a2.5 2.5 0 0 1-3-2.88z" /></>);
export const MessageIcon = () => svg(<path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8z" />);
// "Open in the standalone app" — the conventional box-with-an-arrow.
export const ExternalLinkIcon = () => svg(<><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" /><path d="M15 3h6v6M10 14 21 3" /></>);
// Restores a collapsed panel (the collapsed state's counterpart to MinusIcon).
export const ChevronUpIcon = () => svg(<path d="m18 15-6-6-6 6" />);
